import { useState, useEffect } from "react";
import { FaList } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaRegPlusSquare } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";

const List = ({apiUrl}) => {

  const [listData, setListData] = useState([]); 

  const getGyms = async ()=> {
    try {
      const response = await fetch(apiUrl, {
        method: 'GET'
      });
      const GymListData = await response.json();
      setListData(GymListData);
    } catch (error) {
      alert(error.message);
    }
  }

  useEffect(()=>{
    getGyms();
  }, [])

  const deleteGym = async (gymId)=> {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${apiUrl}/${gymId}`, {
            method: 'DELETE'
          })
          if(response.ok){
            Swal.fire(
              'Deleted!',
              'Gym has been deleted.',
              'success'
            );
            getGyms();
          }else{
            const result = await response.json();
            throw new Error(result.message);
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            error.message,
            'error'
          );
        }
      }
    });
  }

  return (
    <div className="container my-3">
      <h1 className="app-header">
        <FaList /> Gym Lists
        <Link to="/add" className="btn btn-primary btn-sm float-end">
          <FaRegPlusSquare /> Add
        </Link>
      </h1>
      <div className="card bg-transparent">
        <ul className="list-group list-group-flush">
          {listData.length === 0 && <div className="alert alert-info mb-0 text-center">No data to be displayed</div>}
          {
            listData.length > 0 && listData.map(gym => (
              <li key={gym.id} className="list-group-item mb-3">
                <div><b>{gym.name}</b></div>
                <div>{gym.username}</div>
                <div>{gym.email}</div>
              </li>
            ))
          }
        </ul>
      </div>
      <div className="gymList">
        
      </div>
    </div>
  )
}

//   return (
//     <div className="container my-3">
//       <h1 className="app-header">
//         <FaList /> Gym Lists
//         <Link to="/add" className="btn btn-primary btn-sm float-end">
//           <FaRegPlusSquare /> Add
//         </Link>
//       </h1>
//       <div className="card bg-transparent">
//         <ul className="list-group list-group-flush">
//           {listData.length === 0 && <div className="alert alert-info mb-0 text-center">No data to be displayed</div>}
//           {
//             listData.length > 0 && listData.map(gym => (
//               <li key={gym._id} className="list-group-item mb-3">
//                 <div><b>{gym.name}</b></div>
//                 <div>{gym.desc}</div>
//                 <div>{gym.createdAt}</div>

//                 <Link to={`edit/${gym._id}`} className="btn btn-success btn-sm">
//                   <FaEdit /> Edit
//                 </Link>
//                 <button className="btn btn-danger btn-sm ms-2" onClick={()=>deleteGym(gym._id)}>
//                   <MdDelete />Delete
//                 </button>
//               </li>
//             ))
//           }
//         </ul>
//       </div>
//       <div className="gymList">
        
//       </div>
//     </div>
//   )
// }

export default List